const debtor_groups = {
	add_button: "Add Debtor Group",
	add_dialog: {
		description: "Add a new debtor group.",
		form: {
			description: "Description",
			name: "Name",
		},
		title: "Add Debtor Group",
	},
	delete_dialog: {
		description: "Do you want to delete debtor group <strong>{{name}}</strong>?",
		group_not_empty: {
			description:
				"There are still debtors linked to this debtor group. Unlink them before removing the debtor group.",
			title: "Group is not empty.",
		},
		title: "Delete Debtor Group",
	},
	disconnect_debtor: {
		description: "Do you want to unlink debtor <strong>{{name}}</strong>?",
		success_alert: "Unlinking of debtor was successful!",
		title: "Unlink Debtor",
		unknown_alert: "Unlinking of debtor was not successful! Please try again later.",
	},
	duplicate_dialog: {
		description: "Add a new debtor group using the values of the selected debtor group.",
		title: "Add Debtor Group",
	},
	edit_dialog: {
		description: "Edit the selected debtor group.",
		title: "Edit Debtor Group",
	},
	status: {
		create: {
			success: "Debtor group has been added!",
			unknown: "Debtor group cannot be added at the moment. Please try again later.",
		},
		delete: {
			not_empty: "Debtor group cannot be deleted because there are still debtors linked to it.",
			success: "Debtor group has been deleted!",
			unknown: "Debtor group cannot be deleted at the moment. Please try again later.",
		},
		edit: {
			success: "Debtor group has been edited!",
			unknown: "The chosen debtor group cannot be edited at the moment. Please try again later.",
		},
	},
	table: {
		description: "Description",
		details: "Details",
		name: "Debtor Group Name",
	},
	title: "Debtor Groups",
};

export default debtor_groups;
